import React, { useState } from "react";
import { FaEnvelope } from "react-icons/fa"; // Envelope icon
import bgimage from '../../Assets/bgimage.PNG';

const ContactInfo = () => {
  const [clicked, setClicked] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "",company: "", message: "" });
  const [response, setResponse] = useState("");
    const backgroundStyle = {
        backgroundImage: `url(${bgimage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '40vh',
    };


  const handleClick = () => {
    setClicked(true);
    setTimeout(() => {
      setClicked(false); // Reset animation after it completes
    }, 3000); // Duration of the animation (3 seconds)
  };
// };
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value, // Correctly update the respective field
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(formData.email)) {
    setResponse("Please enter a valid email address.");
    return;
  }

  try {
    const res = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData), // Sending formData to the backend
    });

    const data = await res.json();
    setResponse(data.message); // Show success or failure message
  } catch (error) {
    setResponse("Failed to send message.");
  }
};


  return (
    <div>
      <div style={backgroundStyle}>
        <h1 className="bheading text-5xl pt-40 md:text-6xl lg:text-6xl font-semibold text-center text-white">
          Contact Us
        </h1>
      </div>

      <div className="min-h-screen py-10 flex items-center justify-center px-4">
        <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Section */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#124E66] mb-4">
              +92 123456789
            </h2>
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700">Address</h3>
              <p className="text-gray-600">
                Roza Luksemburg 15/3, 1000 Skopje, Republic of N. Macedonia
              </p>
            </div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700">Email</h3>
              <p className="text-gray-600">kayeetechofficial@gmail.com</p>
            </div>
            <div className="flex items-center space-x-4 mt-6">
              <a href="#" className="text-gray-500 hover:text-gray-700">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-700">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-700">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Right Section */}
          <div>
            <h3 className="text-[#124E66] font-semibold">LET'S CHAT</h3>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">SEND A MESSAGE</h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#124E66]"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#124E66]"
                />
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  name="company"
                  placeholder="Company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#124E66]"
                />
              </div>
              <div className="mb-4">
                <textarea
                  rows="4"
                  name="message"
                  placeholder="Describe your product"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#124E66]"
                ></textarea>
              </div>
              <button
                type="submit"
                onClick={handleClick}
                className={`w-full md:w-auto px-6 py-3 text-white font-semibold rounded-lg focus:outline-none flex justify-center items-center ${
                  clicked ? "animate-envelope-button" : "bg-[#124E66]"
                }`}
              >
                {clicked ? (
                  <div className="w-24 h-24 flex items-center justify-center rounded-lg animate-envelope-move">
                    <FaEnvelope className="text-[#124E66] text-4xl" />
                  </div>
                ) : (
                  "Let's Talk"
                )}
              </button>
              {response && <p>{response}</p>}
            </form>
          </div>
        </div>
      </div>
            <style jsx>{`
                   /* Prevent overflow */
        body{
          overflow-x: hidden; /* Hide horizontal overflow */
        }
        /* Keyframe animation for the envelope button */
        @keyframes envelopeButton {
          0% {
            transform: scale(1);
            width: 100%;
            height: 3rem;
            border-radius: 0.375rem;
          }
          50% {
            width: 90%;
            height: 5rem;
            border-radius: 0.375rem;
            transform: scale(1.2);
          }
          100% {
            width: 96px;
            height: 96px;
            border-radius: 1rem;
            transform: scale(1);
            opacity: 0;
          }
        }

        /* Animation for moving the envelope from left to right */
        @keyframes envelopeMove {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(100vw); /* Move to the right end of the page */
          }
        }

        .animate-envelope-button {
          animation: envelopeButton 3s ease-in-out forwards;
        }

        .animate-envelope-move {
          animation: envelopeMove 3s ease-in-out forwards;
        }

        }
      `}</style>
    </div>
  );
};

export default ContactInfo;
